import { render } from "./AppTable.vue?vue&type=template&id=31a2931c&scoped=true&lang=pug"
import script from "./AppTable.vue?vue&type=script&lang=ts"
export * from "./AppTable.vue?vue&type=script&lang=ts"

import "./AppTable.vue?vue&type=style&index=0&id=31a2931c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-31a2931c"

export default script